import { Dispatch, SetStateAction } from "react";
import { useCustomModal } from "../../../hooks/modal/useCustomModal";
import useTableRendering from "../../../hooks/table/useTableRendering";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import TableIndicatorAlertSan from "../Alert/TableIndicatorAlertSan";
import { AuthUser } from "../../../types/User/AuthUser";

interface UseAlertSanProps {
  user: AuthUser;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  alertSanDataTable: any[];
  originalAlertSanDataTable: any[];
  setAlertSanDataTable: Dispatch<SetStateAction<any[]>>;
  isLoadedAlertSan: boolean;
  alertSanPageSize: number;
  setAlertSanPageSize: Dispatch<SetStateAction<number>>;
  alertSanTotalItems: number;
  setIdItem: Dispatch<SetStateAction<number>>;
  setValueAlertSan: (name: string, value: any) => void;
}

export const useAlertSan = ({
  user,
  setIsSearching,
  alertSanDataTable,
  originalAlertSanDataTable,
  setAlertSanDataTable,
  isLoadedAlertSan,
  alertSanPageSize,
  setAlertSanPageSize,
  alertSanTotalItems,
  setIdItem,
  setValueAlertSan,
}: UseAlertSanProps) => {
  const {
    isOpen: isOpenAlertSan,
    title: titleAlertSan,
    buttonTitle: buttonTitleAlertSan,
    openModal: openModalAlertSan,
    closeModal: closeModalAlertSan,
  } = useCustomModal("", "");

  const tableConfigAlertaSan: TableConfig = {
    tableName: "Lista de Alertas SAN",
    dataTable: alertSanDataTable,
    originalDataTable: originalAlertSanDataTable,
    setDataTable: setAlertSanDataTable,
    renderTable: (alertSanDataTable) => (
      <TableIndicatorAlertSan
        setIdUpdateItem={setIdItem}
        dataTable={alertSanDataTable}
        isLoaded={isLoadedAlertSan}
        user={user}
        setValue={setValueAlertSan}
        openModal={openModalAlertSan}
      />
    ),
    isLoaded: isLoadedAlertSan,
  };

  const {
    currentPage: alertSanCurrentPage,
    totalPages: alertSanTotalPages,
    handlePageChange: alertSanHandlePageChange,
    renderContent: alertSanRenderContent,
  } = useTableRendering(
    tableConfigAlertaSan,
    alertSanPageSize,
    alertSanTotalItems,
    setIsSearching,
  );

  const paginationConfigAlertSan: PaginationConfig = {
    pageSize: alertSanPageSize,
    currentPage: alertSanCurrentPage,
    totalPages: alertSanTotalPages,
    handlePageChange: alertSanHandlePageChange,
    renderContent: alertSanRenderContent,
    setPageSize: setAlertSanPageSize,
    totalItems: alertSanTotalItems,
  };

  const modalConfigAlertSan: ModalConfig = {
    isOpen: isOpenAlertSan,
    title: titleAlertSan,
    buttonTitle: buttonTitleAlertSan,
    openModal: openModalAlertSan,
    closeModal: closeModalAlertSan,
  };

  return {
    paginationConfigAlertSan,
    modalConfigAlertSan,
    tableConfigAlertaSan,
    alertSanCurrentPage,
  };
};
